import { Injectable } from '@angular/core';

import { isSectionVisible } from 'app/utils/is-section-visible';
import { isValueOfNone } from 'app/utils/is-value-of-none';
import { type AppConfigurationSection } from 'graphql/models/extended';
import { type SelectorSection } from 'graphql/models/product-selector.model';

@Injectable({
  providedIn: 'root'
})
export class OfferSectionService {
  isSectionVisible(section: AppConfigurationSection | SelectorSection): boolean {
    return isSectionVisible(section);
  }

  isValueOfNone(valueOrIdOrName: string, additional = false): boolean {
    return isValueOfNone(valueOrIdOrName, additional);
  }
}
